// 🔧 CONFIGURACIÓN DE API - RUTA /api/v1/
const defaultUrl = '/api/v1';
const localApiUrl = 'http://localhost:5858';
const isLocalHost = () =>
  window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_URL || defaultUrl,
  SOCKET_URL: process.env.REACT_APP_SOCKET_URL || (isLocalHost() ? localApiUrl : window.location.origin),
  TIMEOUT: 30000,
  HEALTH_CHECK_INTERVAL: 30000
};

// 🔧 Función para obtener la URL base de la API
export const getApiBaseUrl = (): string => {
  const envUrl = process.env.REACT_APP_API_URL?.trim();
  const apiUrl = envUrl || (isLocalHost() ? localApiUrl : defaultUrl);
  
  console.log('🔧 API Configuration:');
  console.log('🔧 Hostname:', window.location.hostname);
  console.log('🔧 API_BASE_URL:', apiUrl);
  console.log('🚀 Modo API:', envUrl ? 'variable de entorno' : (isLocalHost() ? 'desarrollo local' : 'producción path-based'));
  
  return apiUrl;
};

// 🔧 Función para obtener la URL del socket
export const getSocketUrl = (): string => {
  return process.env.REACT_APP_SOCKET_URL?.trim() || API_CONFIG.SOCKET_URL;
};

export default API_CONFIG;

 
